export type StatusKey = "available" | "mirror" | "maintenance";

export const statusConfig: Record<
  StatusKey,
  { label: string; dot: string; badge: string }
> = {
  available: {
    label: "可用",
    dot: "bg-primary-500",
    badge: "bg-primary-100 text-primary-900 border-primary-200",
  },
  mirror: {
    label: "镜像",
    dot: "bg-accent-500",
    badge: "bg-accent-100 text-accent-900 border-accent-200",
  },
  maintenance: {
    label: "维护中",
    dot: "bg-background-400",
    badge: "bg-background-200 text-foreground-600 border-background-300",
  },
};